import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* getCharacterFavorite({params}) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_CHARACTER_FAVORITE)
    );
    yield put(actionCreators.getCharacterFavoriteSuccess(response.data.data));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    
  }
}

function* characterFavorite() {
  yield takeLatest(actionTypes.GET_CHARACTER_FAVORITE, getCharacterFavorite);
}

export default characterFavorite;
